<div class="p-grid">
    <form class="p-md-7 p-col-12" [formGroup]="formData" *ngIf="formData">
        <div class="mu-input-form-container p-grid">
            <app-mu-form-fieldset class="p-pr-6">
                <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingCreateForm.labels.selectVehicle' | translate}}</h3>
                <app-mu-radio-icon
                    [formData]="formData"
                    [label]="'bike'"
                    [controlName]="'vehicleType'"
                    [value]="'MOTO'"
                    [icon]="'mu-icon-bike'"
                ></app-mu-radio-icon>
            </app-mu-form-fieldset>
            <app-mu-form-fieldset class="p-pr-6" id="mu-input-form-radio-icon-truck-container">
                <app-mu-radio-icon
                    [formData]="formData"
                    [label]="'truck'"
                    [controlName]="'vehicleType'"
                    [value]="'CAMIÓN'"
                    [icon]="'mu-icon-truck'"
                ></app-mu-radio-icon>
            </app-mu-form-fieldset>
        </div>
        <div class="mu-input-form-container p-grid">
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingCreateForm.labels.ServiceDate' | translate}}</h3>
                    <app-mu-calendar
                        formControlName="serviceDate"
                        placeholder="{{ 'context.massive.newRouting.routingCreateForm.placeholders.date' | translate}}"
                        dateFormat="dd/mm/yy"
                        [minDate]="startDate"
                    ></app-mu-calendar>
                </div>
            </app-mu-form-fieldset>
        </div>
        <div class="mu-input-form-container p-grid">
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingCreateForm.labels.startHour' | translate}}</h3>
                    <app-mu-calendar 
                        formControlName="serviceDateStartHour"
                        [hourFormat]="24"
                        [maxDate]="formData?.get('serviceDateEndtHour')?.value"
                        [showTime]="true"
                        [timeOnly]="true"
                        placeholder="{{ 'context.massive.newRouting.routingCreateForm.placeholders.startHour' | translate}}"
                    ></app-mu-calendar>
                </div>
            </app-mu-form-fieldset> 
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingCreateForm.labels.endHour' | translate}}</h3>
                    <app-mu-calendar 
                        formControlName="serviceDateEndtHour"
                        [hourFormat]="24"
                        [minDate]="formData?.get('serviceDateStartHour')?.value"
                        [showTime]="true"
                        [timeOnly]="true"
                        placeholder="{{ 'context.massive.newRouting.routingCreateForm.placeholders.endHour' | translate}}"
                    ></app-mu-calendar>
                </div>
            </app-mu-form-fieldset> 
        </div>
        <div class="p-grid">
            <app-mu-button 
                [flagList]="flagList"
                [flag]="backToDeliveriesFlag"
                [label]="'context.massive.newRouting.routingCreateForm.buttons.back' | translate"
                class="mu-button-outline p-md-6 p-col-12 p-my-0"
                >
            </app-mu-button>
            <app-mu-button 
                [flagList]="flagList"
                [flag]="continueToCreateServiceFlag"
                [label]="'context.massive.newRouting.routingCreateForm.buttons.createService' | translate"
                class="p-md-6 p-col-12 p-my-0"
                [disabled]="formData.invalid"
                >
            </app-mu-button>
        </div>
    </form>
</div>